@if (
  {
    row: columnData | async,
    adata: additionData | async,
  };
  as $
) {
  @if (showButton) {
    <button
      pButton
      pRipple
      type="button"
      icon="fa fa-plus"
      [label]="$.adata.label"
      iconPos="left"
      (click)="executeAction('add', $.row)"
      class="text-sm text-600 p-button-outlined p-button-primary border-400 p-2"
    ></button>
  }
}
